var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    directives: [
      {
        name: "model",
        rawName: "v-model",
        value: _vm.formValue,
        expression: "formValue"
      }
    ],
    staticClass: "c-radio__input",
    attrs: {
      name: _vm.formName,
      type: "radio",
      disabled: _vm.disabled,
      readonly: _vm.readonly
    },
    domProps: {
      value: _vm.refValue,
      checked: _vm._q(_vm.formValue, _vm.refValue)
    },
    on: {
      change: function($event) {
        _vm.formValue = _vm.refValue
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }